<template>
  <div id="detalleReposicion">
      <v-toolbar>
        <img src="@/assets/logo_javer.png" height="60" width="auto">
        <v-spacer></v-spacer>
        <v-toolbar-title>Detalle de reposición fondo fijo de caja</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs6>
              <v-container>
                <h3 class="grey--text">GENERAL</h3><br/>
                <v-radio-group v-model="detalleReposicion.general.tipoSolicitud">
                  <div slot="label"><strong>Tipo de solicitud</strong></div>
                  <v-radio label="Cheque" color="primary" value="cheque"></v-radio>
                  <v-radio label="Depósito electrónico" color="primary" value="deposito_electronico"></v-radio>
                </v-radio-group>
                <v-radio-group v-model="detalleReposicion.general.tipoPago">
                  <div slot="label"><strong>Tipo de pago</strong></div>
                  <v-radio label="Gastos comprobables" color="primary" value="gastos_comprobables"></v-radio>
                  <v-radio label="Otros" color="primary" value="otros"></v-radio>
                </v-radio-group><br/>
                <v-text-field v-model="reposicion.monto" prefix="$" suffix="MXN" label="Fondo fijo autorizado"></v-text-field>
                <br/>
                <template v-if="detalleReposicion.general.tipoSolicitud === 'deposito_electronico'">
                  <h3 class="grey--text">DATOS DE DEPÓSITO</h3><br/>
                  <v-text-field v-model="detalleReposicion.general.banco" label="Banco"></v-text-field>
                  <v-text-field v-model="detalleReposicion.general.cuenta" label="No. Cuenta"></v-text-field>
                  <v-text-field v-model="detalleReposicion.general.tarjeta" label="No. Tarjeta"></v-text-field>
                  <v-text-field v-model="detalleReposicion.general.clabe" label="Referencia interbancaria"></v-text-field><br/>
                </template>
                <h3 class="grey--text">FIRMAS</h3><br/>
                <v-list three-line>
                  <template v-for="(item, i) in detalleReposicion.firmas">
                    <v-list-tile class="pb-2 pt-2">
                      <v-list-tile-content>
                        <v-list-tile-title v-html="item.rol"></v-list-tile-title>
                        <v-list-tile-title v-html="item.nombre"></v-list-tile-title>
                        <v-list-tile-sub-title v-html="item.estado"></v-list-tile-sub-title>
                        <v-list-tile-sub-title v-show="item.estado !== 'En aprobación'" v-html="item.fecha_actualizacion"></v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider v-show="(i + 1) < detalleReposicion.firmas.length"></v-divider>
                  </template>
                </v-list>
              </v-container>
            </v-flex>
            <v-flex xs6>
              <v-container>
                <h3 class="grey--text">DATOS DE CAJA CHICA</h3><br/>
                <v-text-field v-model="reposicion.empresa" label="Empresa"></v-text-field>
                <br/>
                <h3 class="grey--text">DATOS DEL SOLICITANTE</h3><br/>
                <v-text-field v-model="reposicion.unidad" label="Unidad de negocio"></v-text-field>
                <v-text-field v-model="reposicion.plaza" label="Plaza"></v-text-field>
                <v-text-field v-model="reposicion.centro" label="Centro de costos"></v-text-field>
                <v-text-field v-model="reposicion.beneficiario" label="Beneficiario"></v-text-field>
                <br/>
                <h3 class="grey--text">FACTURAS</h3><br/>
                <v-text-field v-model="detalleReposicion.resumen.no_facturas" class="pt-3" label="No. Facturas"></v-text-field>
                <v-text-field v-model="detalleReposicion.resumen.subtotal" label="Subtotal" prefix="$" suffix="MXN"></v-text-field>
                <v-text-field v-model="detalleReposicion.resumen.iva" label="IVA" prefix="$" suffix="MXN"></v-text-field>
                <v-text-field v-model="detalleReposicion.general.importe_total" label="Importe por reembolsar" prefix="$" suffix="MXN"></v-text-field>
              </v-container>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
  </div>
</template>

<script>
import axios from 'axios'
import services from '@/config/services'

export default {
  name: 'detalleReposicion',
  data: () => ({
    loading: false,
    reposicion: {
      tipoSolicitud: null,
      tipoPago: null,
      monto: '',
      banco: '',
      cuenta: '',
      tarjeta: '',
      clabe: '',
      empresa: '',
      unidad: '',
      plaza: '',
      centro: '',
      beneficiario: '',
      facturas: {
        importe_total: '',
        no_facturas: 0,
        subtotal: 0,
        iva: 0,
        nueva: {
          tipo_gasto: 'deducible',
          pdf: { nombre: '', data: null },
          xml: { nombre: '', data: null },
          foto: { nombre: '', data: null },
          concepto: '',
          razon_social: '',
          rfc: '',
          no_factura: '',
          proveedor_frontera: false,
          importe: '',
          iva: '',
          total: ''
        },
        detalle: []
      }
    },
    detalleReposicion: {
      general: {
        tipoSolicitud: null,
        tipoPago: null,
        monto: '',
        banco: '',
        cuenta: '',
        tarjeta: '',
        clabe: '',
        importe_total: ''
      },
      facturas: [],
      resumen: {
        no_facturas: 0,
        subtotal: 0,
        iva: 0
      },
      firmas: []
    },
    detalleUsuario: {
      area: null,
      nombre: '',
      puesto: '',
      departamento: '',
      oficina: '',
      centro: '',
      importe: '',
      detalle: '',
      empresa: '',
      observaciones: ''
    },
  }),
  mounted() {
    var token = this.getQueryVariable('token')
    var id_repo = this.getQueryVariable('id_repo')
    var id_caja = this.getQueryVariable('id_caja')
    this.$session.start()
    this.$session.set('jwt', token)
    this.detailRequest(id_caja);
    this.showDetailRep(id_repo);
  },
  methods: {
    ws(method, name, data) {
      if (method === 'get') {
        if (this.$session.exists()) {
          let jwt = this.$session.get('jwt')
          let headers = {
            'Authorization': 'Bearer ' + jwt
          }
          let params = ''
          for (let k in data) {
            params += k + '=' + data[k] + '&'
          }
          params = (params !== '') ? '?' + params : ''
          return axios.get(services.routes[name] + params, { headers })
            .then(response => {
              let res = response.data
              if (res.correcto) {
                return { ok: true, data: res.data, message: res.mensaje }
              } else {
                return { ok: false, message: res.mensaje }
              }
            })
            .catch(error => {
              console.log(error)
              error.response.status === 403 && this.$router.push('/403')
              return { ok: false, message: 'El servicio no se encuentra disponible en estos momentos' }
            })
        } else {
          this.$router.push('/login')
        }
      }
      else {
        if (this.$session.exists()) {
          let jwt = this.$session.get('jwt')
          let headers = {
            'Authorization': 'Bearer ' + jwt
          }
          return axios.post(services.routes[name], data, { headers })
            .then(response => {
              let res = response.data
              if (res.correcto) {
                return { ok: true, data: res.data, message: res.mensaje }
              } else {
                return { ok: false, message: res.mensaje }
              }
            })
            .catch(error => {
              console.log(error)
              error.response.status === 403 && this.$router.push('/403')
              return { ok: false, message: 'El servicio no se encuentra disponible en estos momentos' }
            })
        } else {
          this.$router.push('/login')
        }
      }
    },
    getQueryVariable(variable) {
      var query = window.location.search.substring(1)
      var vars = query.split("&")
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=")
        if (pair[0] == variable){
          return pair[1]
        }
      }
      return(false);
    },
    prepareDetailForm (data) {
      this.detalleUsuario.nombre = data.detalle_usuario.nombre + ' ' + data.detalle_usuario.apellido_paterno + ' ' +
      data.detalle_usuario.apellido_materno
      this.detalleUsuario.nombre = this.detalleUsuario.nombre.trim();
      this.detalleUsuario.puesto = data.detalle_usuario.puesto
      this.detalleUsuario.departamento = data.detalle_usuario.departamento
      this.detalleUsuario.oficina = data.detalle_usuario.ubicacion
      this.detalleUsuario.area = data.solicitud.area
      this.detalleUsuario.centro = data.solicitud.centro
      this.detalleUsuario.importe = data.solicitud.importe.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      this.detalleUsuario.letra = data.solicitud.letra
      this.detalleUsuario.detalle = data.solicitud.detalle
      this.detalleUsuario.empresa = data.solicitud.empresa
      this.detalleUsuario.observaciones = data.solicitud.observaciones
      this.reposicion.monto = data.solicitud.importe.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      this.reposicion.banco = data.detalle_usuario.banco
      this.reposicion.cuenta = data.detalle_usuario.cuenta
      this.reposicion.tarjeta = data.detalle_usuario.tarjeta
      this.reposicion.clabe = data.detalle_usuario.clabe
      this.reposicion.empresa = data.solicitud.empresa
      this.reposicion.unidad = data.detalle_usuario.unidad
      this.reposicion.plaza = data.detalle_usuario.plaza
      this.reposicion.centro = data.solicitud.centro
      this.reposicion.beneficiario = this.detalleUsuario.nombre
    },
    detailRequest(id) {
      this.loading = true
      this.ws('get', 'detalleSolicitudCajaChica', { id })
        .then(res => {
          if (res.ok) {
            this.prepareDetailForm(res.data)
          }
          else {
            this.msgError = res.message
            this.alert = true
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    showDetailRep(id) {
      this.loading = true
      this.ws('get', 'detalleReposicionCajaChica', { id })
        .then(res => {
          if (res.ok) {
            this.detalleReposicion.general.tipoSolicitud = res.data.reposicion.tipo_solicitud
            this.detalleReposicion.general.tipoPago = res.data.reposicion.tipo_pago
            this.detalleReposicion.general.banco = res.data.reposicion.banco
            this.detalleReposicion.general.cuenta = res.data.reposicion.cuenta
            this.detalleReposicion.general.tarjeta = res.data.reposicion.tarjeta
            this.detalleReposicion.general.clabe = res.data.reposicion.clabe
            this.detalleReposicion.general.importe_total = res.data.reposicion.importe_total.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            this.detalleReposicion.facturas = res.data.facturas
            this.detalleReposicion.resumen.no_facturas = res.data.facturas.length
            let subtotal = 0
            let iva = 0
            for (let i = 0; i < res.data.facturas.length; i++) {
              subtotal += parseFloat(parseFloat(res.data.facturas[i].importe).toFixed(2))
              iva += parseFloat(parseFloat(res.data.facturas[i].iva).toFixed(2))
            }
            this.detalleReposicion.resumen.subtotal = subtotal.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            this.detalleReposicion.resumen.iva = iva.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            this.detalleReposicion.firmas = res.data.firmas
            this.dialogDetRep = true
          }
          else {
            this.error = true
            this.msgError = res.message
          }
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
